// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { createAction, createReducer } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

import { defaultThemeReducer, ThemeType } from "./types";

export const themeReducerKey = "theme";

export const changeTheme = createAction<ThemeType>("theme/change");
export const changeShowBalance = createAction<boolean>("theme/changeShowBalance");
export const toggleShowBalance = createAction("theme/toggleShowBalance");
export const changeCoinsShowList = createAction<boolean>("theme/changeCoinsShowList");
export const toggleCoinsShowList = createAction("theme/toggleCoinsShowList");

const themeReducer = createReducer(defaultThemeReducer, (builder) =>
  builder
    .addCase(changeTheme, (state, action) => {
      state.theme = action.payload;
    })
    .addCase(changeShowBalance, (state, action) => {
      state.showBalance = action.payload;
    })
    .addCase(toggleShowBalance, (state) => {
      state.showBalance = !state.showBalance;
    })
    .addCase(changeCoinsShowList, (state, action) => {
      state.coinsShowList = action.payload;
    })
    .addCase(toggleCoinsShowList, (state) => {
      state.coinsShowList = !state.coinsShowList;
    }),
);

export const selectTheme = (state: RootState) => state.theme;

export default themeReducer;
